type FilterPaginationQueryParams<TFilter> = {
  filter: TFilter;
  page?: number;
  perPage?: number;
  order?: string;
};

/**
 * Builds query string url params for filtering & pagination for list endpoints.
 *
 * Input: { filter: { incidentId: '1', aorIds: ['1', '2'] }, page: 1 }
 *
 * Output: { 'filter[incidentId]': '1', 'filter[aorIds]': '1,2', page: '1' }
 */
export function buildSearchQueryParams<TFilter>({
  filter,
  page,
  perPage,
  order,
}: FilterPaginationQueryParams<TFilter>) {
  const params = { page, perPage, order };
  const formattedQuery: Record<string, string> = {};

  Object.entries(filter || {}).forEach(([key, value]) => {
    if (value === undefined || value === null) return;

    const formattedValue = Array.isArray(value)
      ? value.join(',')
      : String(value);

    formattedQuery[`filter[${key}]`] = formattedValue;
  });

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      formattedQuery[key] = String(value);
    }
  });

  return formattedQuery;
}
